import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['start', 'end', 'dates', 'datesChosen', 'select']

  connect() {
    this.picker = new Lightpick({
      field: this.startTarget,
      secondField: this.endTarget,
      startDate: moment(this.startTarget.value),
      endDate: moment(this.endTarget.value),
      singleDate: false,
      onSelect: this.select
    })
  }

  open() {
    this.picker.show()
  }

  change() {
    if (this.selectTarget.value != '') {
      this.selectTarget.form.requestSubmit()
    }
  }

  submit() {
    this.selectTarget.form.requestSubmit()
  }


  select = (start, end) => {
    var str = '';
    str += start ? start.format('MMM D YYYY') + ' - ' : '...'
    str += end ? end.format('MMM D YYYY') : '...'
    this.datesTarget.innerHTML = str
    if (typeof start._i != 'string' && typeof end._i != 'string') {
      this.selectTarget.value = ''
      this.datesChosenTarget.value = 'true'
      this.element.requestSubmit()
    }
  }
}
